/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */

import React from 'react';
import { Icon } from 'semantic-ui-react';

const iconStyle = { lineHeight: 1, height: '1em', margin: 0 };

// expected props
// - mode, as 'or' or 'and'
// - filters, as array of { key, value, icon }
export default function FilterList({ mode, filters }) {
  if (filters.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', paddingTop: '8px' }}>
      <span className="study-pill" style={{ background: '#f0f0ff', color: 'var(--rmit-blue)' }}>
        Mode: {mode.toUpperCase()}
      </span>
      {filters.map(({ key, value, icon }) => {
        const display = value.filter(Boolean).join(', ');
        if (!display) return null;
        return (
          <span key={key} className="study-pill" style={{ background: '#f3f4f6', color: '#374151' }}>
            <Icon name={icon} style={{ ...iconStyle, fontSize: '0.85em' }} />
            {display}
          </span>
        );
      })}
    </div>
  );
}
